import { api } from './api';

/* Mirrors Eduvora.Application.Results. ⚠ No money field anywhere — teachers can open this. */

export interface ClassOption { classKey: string; classLabel: string; students: number }

export interface SubjectMark {
  subject: string;
  /** null with isAbsent false means the mark has not been entered yet. */
  marks: number | null;
  maxMarks: number;
  isAbsent: boolean;
}

export interface StudentResultRow {
  studentId: string;
  fullName: string;
  admissionNumber: string;
  /** 0 = not ranked (sat nothing). Ties share a position. */
  position: number;
  subjects: SubjectMark[];
  obtained: number;
  max: number;
  percent: number;
  absent: number;
}

export interface SubjectSummary {
  subject: string; average: number; highest: number; lowest: number; belowForty: number; sat: number;
}

/** One entry in the assessment picker: a single named sitting, or an aggregate of a whole kind. */
export interface AssessmentOption {
  /** For a named sitting this is the exam name itself, so old deep links keep working.
      Aggregates are "agg:<kind>". */
  key: string;
  label: string;
  kindLabel: string;
  sittings: number;
  isAggregate: boolean;
  /** "Best 2 of 3, averaged" — null for a single sitting. */
  rule: string | null;
  /** On the calendar, but nobody has entered a mark yet. */
  isScheduled: boolean;
}

export interface ClassResults {
  classes: ClassOption[];
  classKey: string | null;
  classLabel: string | null;
  assessments: AssessmentOption[];
  assessment: string | null;
  assessmentLabel: string | null;
  assessmentRule: string | null;
  subjectOrder: string[];
  students: StudentResultRow[];
  subjects: SubjectSummary[];
  classAverage: number | null;
  highest: number | null;
  lowest: number | null;
  sat: number;
  note: string | null;
}

/** Build the server's class key from a command-centre row, so the dashboard can deep-link here. */
export function classKeyOf(academicClassId: string | null, classLabel: string): string {
  return academicClassId
    ? 'c:' + academicClassId.replace(/-/g, '').toLowerCase()
    : 'l:' + classLabel.trim().toLowerCase();
}

export const resultsApi = {
  sheet: (classKey?: string | null, assessment?: string | null) => {
    const p = new URLSearchParams();
    if (classKey) p.set('classKey', classKey);
    if (assessment) p.set('assessment', assessment);
    const qs = p.toString();
    return api.get<ClassResults>(`/api/results/class${qs ? '?' + qs : ''}`);
  },
};
